import { Colors } from '@microfrontends/react-components'
import styled, { css } from 'styled-components'

export const STContainer = styled.div<{ isMobile: boolean }>`
	width: 100%;
	display: flex;
	align-items: center;
	gap: 32px;

	${({ isMobile }) =>
		isMobile &&
		css`
			flex-direction: column;
		`}
`

// banner
export const STImage = styled.div`
	flex: 1;
	width: 100%;

	> div {
		width: 100%;
		position: relative;
		padding-bottom: 50%;

		img {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
		}
	}
`

// content
export const STContent = styled.div`
	flex: 1;
`

export const STSubTitle = styled.a`
	font-family: 'Dela Gothic One';
	font-style: normal;
	font-weight: 400;
	font-size: 24px;
	line-height: 32px;

	display: flex;
	align-items: center;
	color: ${Colors.darkBlue};

	@media (max-width: 769px) {
		font-size: 16px;
		line-height: 24px;
	}

	@media (max-width: 426px) {
		font-size: 14px;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
`

export const STButton = styled.a`
	width: 215px;
	color: unset;

	@media (max-width: 426px) {
		width: 100%;
	}
`

// countdown
export const STCountdown = styled.div`
	margin: 16px 0 24px;
	height: 64px;

	display: flex;
	gap: 16px;
`

export const STDay = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 64px;
	height: 64px;
	border-radius: 4px;
	background: ${Colors.primary};
	color: #fff;

	@media (max-width: 426px) {
		width: 34px;
		min-width: 34px;
		height: 34px;
	}

	p {
		margin: 0;
		font-family: 'Inter';
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 28px;

		@media (max-width: 426px) {
			font-size: 10px;
			line-height: 14px;
		}
	}

	p:nth-of-type(2) {
		font-weight: 700;
		font-size: 20px;
		line-height: 22px;

		@media (max-width: 426px) {
			font-size: 10px;
			line-height: 14px;
		}
	}
`

export const STTimeContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	p {
		margin: 0;
		font-family: 'Inter';
		font-style: normal;
		font-weight: 400;
		font-size: 12px;
		line-height: 18px;
		color: #888888;
	}
`

export const STTimeWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`

export const STTime = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 4px;
	gap: 10px;
	width: 42px;
	height: 37px;
	background: #efefef;
	border-radius: 6px;

	font-family: 'Dela Gothic One';
	font-style: normal;
	font-weight: 400;
	font-size: 20px;
	line-height: 29px;

	text-align: center;
	color: ${Colors.primary};

	@media (max-width: 426px) {
		width: 31px;
		height: 28px;
		font-size: 14px;
		line-height: 20px;
	}
`

export const STDots = styled.div`
	font-family: 'Dela Gothic One';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	text-align: center;

	color: #000000;
`
